module.exports = __webpack_public_path__ + "img/excavation_poi.0cc20093.svg";